import {api} from './api';
import { NewUser, User } from '../model/user';

export const getUser = async (accessToken: string, userId: string): Promise<User> => {
    const response = await api.get<User>(`/users/${userId}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    })

    return response.data as User
}

export const getUsers = async (accessToken: string): Promise<User[]> => {
    const response = await api.get<User[]>(`/users`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });

    return response.data as User[]
}

export const addUsers = async (accessToken: string, users: NewUser[]): Promise<User[]> => {
    const response = await api.post(`/users`, users, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });

    return response.data as User[]
}

export const updateUsers = async (accessToken: string, users: User[]): Promise<User[]> => {
    const response = await api.put(`/users`, users, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.data as User[]
}

export const deleteUser = async (accessToken: string, userId: string): Promise<boolean> => {
    const response = await api.delete(`/users/${userId}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    })

    return response.status == 204 || response.status == 200
}

